var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteBin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#7E1A1A",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 17H32V19H30V32C30 32.5523 29.5523 33 29 33H15C14.4477 33 14 32.5523 14 32V19H12V17H17V14C17 13.4477 17.4477 13 18 13H26C26.5523 13 27 13.4477 27 14V17ZM28 19H16V31H28V19ZM19 22H21V28H19V22ZM23 22H25V28H23V22ZM19 15V17H25V15H19Z",
    fill: "#FF2626"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteBin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete-bin.2a2616857dde0941a546503c8cf06052.svg";